import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import Blank from "@/views/Blank.vue";

const Auth = () => import(/* webpackChunkName: "auth" */ "@/views/Auth.vue");
const DiscordAuth = () => import(/* webpackChunkName: "auth" */ "@/components/auth/DiscordAuth.vue");
const StandaloneAuth = () => import(/* webpackChunkName: "auth" */ "@/components/auth/StandaloneAuth.vue");

import StatCalc from "@/components/general/StatCalc.vue";

const Jobs = () => import(/* webpackChunkName: "jobs" */ "@/views/Jobs.vue");
const JobView = () => import(/* webpackChunkName: "jobs" */ "@/components/job/JobView.vue");

const Items = () => import(/* webpackChunkName: "old-items" */ "@/old/items/Items.vue");
const Item = () => import(/* webpackChunkName: "old-items" */ "@/old/items/Item.vue");
const ItemSearch = () => import(/* webpackChunkName: "old-items" */ "@/old/items/ItemSearch.vue");
const ItemSearchEx = () => import(/* webpackChunkName: "items" */ "@/components/item/ItemSearchEx.vue");
const ItemHome = () => import(/* webpackChunkName: "old-items" */ "@/old/items/ItemHome.vue");
const ItemToolkit = () => import(/* webpackChunkName: "old-items" */ "@/old/items/ItemToolkit.vue");
const ItemToolkitIndex = () => import(/* webpackChunkName: "old-items" */ "@/old/items/ItemToolkitIndex.vue");
const ItemDrop = () => import(/* webpackChunkName: "old-items" */ "@/old/items/ItemDrop.vue");
const ItemDropGroup = () => import(/* webpackChunkName: "old-items" */ "@/old/items/ItemDropGroup.vue");
const ItemShopToolkit = () => import(/* webpackChunkName: "items" */ "@/components/item/shop/ShopToolKit.vue");
const TitleList = () => import(/* webpackChunkName: "items" */ "@/components/item/TitleList.vue");
const CashShopBrowser = () => import(/* webpackChunkName: "items" */ "@/components/item/cashshop/CashShopBrowser.vue");

const Maps = () => import(/* webpackChunkName: "maps" */ "@/views/Maps.vue");
const MapViewMock = () => import(/* webpackChunkName: "maps" */ "@/components/map/MapViewMock.vue");

const Monsters = () => import(/* webpackChunkName: "monsters" */ "@/views/Monsters.vue");
const Monster = () => import(/* webpackChunkName: "monsters" */ "@/components/monsters/MonsterView2.vue");

const Skills = () => import(/* webpackChunkName: "skills" */ "@/views/Skills.vue");
const SkillView = () => import(/* webpackChunkName: "skills" */ "@/components/skill/SkillView.vue");
const SkillSimView = () => import(/* webpackChunkName: "skills" */ "@/views/SkillSimView.vue");

const UiStrings = () => import(/* webpackChunkName: "text" */ "@/old/uistrings/UiStrings.vue");
const UiStringBrowse = () => import(/* webpackChunkName: "text" */ "@/old/uistrings/UiStringBrowse.vue");
const UiStringMidLup = () => import(/* webpackChunkName: "text" */ "@/old/uistrings/UiStringMidLup.vue");

import NotFound from "@/views/NotFound.vue";

Vue.use(Router)

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/auth",
            component: Auth,
            children: [
                {
                    path: "discord",
                    component: DiscordAuth,
                    meta: {
                        redemption: true,
                    },
                },
                {
                    path: "redirect",
                    component: StandaloneAuth,
                    name: "auth",
                    meta: {
                        redemption: true,
                    },
                }
            ],
        },
        {
            // unsurfaced tool; reachable by direct URL only
            path: "/general/stat",
            component: StatCalc,
        },
        {
            path: "/jobs",
            component: Blank,
            meta: {
                auth: !process.env.VUE_APP_ALLOW_UNAUTH,
            },
            children: [
                {
                    path: "",
                    name: "jobs",
                    component: Jobs,
                },
                {
                    path: ":jobId",
                    name: "job-view",
                    component: JobView,
                    props: true,
                }
            ],
        },
        {
            path: "/items",
            component: Items,
            meta: {
                auth: !process.env.VUE_APP_ALLOW_UNAUTH,
            },
            children: [
              {
                path: '',
                name: 'item-home',
                component: ItemHome
              },
              {
                path: 'search',
                name: 'item-search',
                component: !!process.env.VUE_APP_ITEMSEARCHEX ? ItemSearchEx : ItemSearch,
              },
              {
                  path: 'titles',
                  name: 'titles',
                  component: TitleList,
              },
              {
                  path: 'cashshop/:sn?',
                  name: 'item-cash-shop',
                  component: CashShopBrowser,
              },
              {
                  //  Old ItemAcquire links pointed here; the page never existed.
                  path: 'cash/:sn',
                  redirect: (to: any) => `/items/cashshop/${to.params.sn}`,
              },
              {
                path: ':itemId',
                name: 'item-view',
                component: Item
              },
              {
                path: 'toolkit',
                component: ItemToolkit,
                children: [
                  {
                    path: 'index',
                    name: 'item-toolkit',
                    component: ItemToolkitIndex
                  },
                  {
                    path: 'dropgroup/:id?',
                    name: 'item-drop-group',
                    component: ItemDropGroup
                  },
                  {
                    path: 'drop/:id?',
                    name: 'item-drop',
                    component: ItemDrop
                  },
                  {
                    path: 'itemshop/:id?',
                    name: 'item-shop',
                    component: ItemShopToolkit,
                  },
                ]
              }
            ]
        },
        {
            path: "/maps",
            component: Blank,
            meta: {
                auth: !process.env.VUE_APP_ALLOW_UNAUTH,
            },
            children: [
                {
                    path: "",
                    name: "maps",
                    component: Maps,
                },
                {
                    path: ":id",
                    name: "map-view",
                    props: true,
                    component: MapViewMock,
                }
            ],
        },
        {
            path: "/monsters",
            component: Blank,
            meta: {
                auth: !process.env.VUE_APP_ALLOW_UNAUTH,
            },
            children: [
                {
                    path: "",
                    name: "monsters",
                    component: Monsters,
                },
                {
                    path: ":monsterSlug",
                    name: 'monster-view',
                    props: true,
                    component: Monster,
                }
            ],
        },
        {
            path: "/skills",
            component: Blank,
            meta: {
                auth: !process.env.VUE_APP_ALLOW_UNAUTH,
            },
            children: [
                {
                    path: "",
                    name: "skills",
                    component: Skills,
                },
                {
                    path: 'skillSim',
                    name: 'skill-sim',
                    component: SkillSimView,
                    props: true,
                },
                {
                    path: ":skillSlug",
                    name: "skill-view",
                    props: true,
                    component: SkillView,
                },
            ],
        },
        {
            path: "/text",
            component: Blank,
            meta: {
                auth: !process.env.VUE_APP_ALLOW_UNAUTH,
            },
            children: [
                {
                    path: '',
                    redirect: 'uistring',
                },
                {
                    path: "uistring",
                    component: UiStrings,
                    children: [
                      {
                        path: '',
                        redirect: 'browse'
                      },
                      {
                        path: 'browse',
                        component: UiStringBrowse,
                        name: 'uistring-browse',
                      },
                      {
                        path: 'midlup',
                        name: 'uistring-midlup',
                        component: UiStringMidLup
                      },
                      {
                        path: '*',
                        component: NotFound
                      }
                    ]
                },
            ],
        },
        {
            path: "*",
            component: NotFound,
        },
    ]
})
